export const getAll = async () => {
    const response = await fetch(`sprints`);
    return await response.json();
};

export default {
    getAll
}